module.exports = __webpack_public_path__ + "static/media/bgTentangPerusahaan.9d9e3b70.jpg";